export default "__VITE_ASSET__VbkBHOak__"